import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from "react";
import {AdressCardData, Parking} from "../types/types";
import {
    Box, Container, Divider, Paper, Table,
    TableBody,
    TableCell, TableContainer, TableHead, TableRow, useMediaQuery, useTheme
} from "@mui/material";
import stationnement_mairie from "../assets/img/stationnement_mairie.png";
import stationnement_pepiniere from "../assets/img/parking-pepiniere.jpeg";
import lign_p from "../assets/img/ligne-p.png";
import lign_r from "../assets/img/ligne-r.png";
import parkingForbiddenIcon from '../assets/icons/no_parking.png';
import parkingIcon from '../assets/icons/parking.png';
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import TrainIcon from "@mui/icons-material/Train";


const adressesCardsData: AdressCardData[] = [
    {
        id: "1",
        imageUrl: "https://faremoutiers.portailcitoyen.eu/images/front/v2/clients/faremoutiers/homegallery/Mairie.JPG",
        title: "Mairie de Faremoutiers",
        address: "Avenue Victor Massoul 77515, Faremoutiers",
        link: "https://maps.app.goo.gl/J3a8u3awhxnwAw6u7"
    },
    {
        id: "2",
        imageUrl: "https://www.lapepiniere.info/wp-content/uploads/Photo-H5.png",
        title: "Domaine de la Pépinière",
        address: "13 Rue du Plessis, 77126 Châtenay-sur-Seine",
        link: "https://maps.app.goo.gl/oHwVHEN2gFS4kgkQ6"
    }
];

const parkingsData: Parking[] = [
    {
        ok: true,
        name: "Parking rue du 27 août 1944",
        comment: "9 places (4 min à pieds)"
    },
    {
        ok: true,
        name: "Parking au 33 boulevard Lambert de Mée",
        comment: "40 places (6 min à pieds)"
    },
    {
        ok: false,
        name: "Parking du centre ville",
        comment: "Interdit avant 15h le samedi à cause du marché"
    }
];

const howToComeData = [
    {
        lieu: "📍 Mairie de Faremoutiers",
        gare: "Faremoutiers – Pommeuse",
        distance: "10 min à pied",
        ligneImg: lign_p,
        ligneLabel: "Paris Est - Coulommiers",
    },
    {
        lieu: "🌿 Domaine de la Pépinière",
        gare: "Montereau",
        distance: "20 min en voiture",
        ligneImg: lign_r,
        ligneLabel: "Gare de Lyon - Montereau",
    },
];


const HowToCome: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <>
            <Box    >
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{mb: 4, color: 'text.primary', textAlign: 'center'}}
                >
                    Lieux
                </Typography>

                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 4,
                        justifyContent: 'center',
                        mb: 6
                    }}
                >
                    {adressesCardsData.map((item) => (
                        <Box key={item.id} >
                            <Card sx={{height: '100%'}}>
                                <CardMedia
                                    sx={{height: 200}}
                                    image={item.imageUrl}
                                    title={item.title}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {item.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{color: 'text.secondary'}}>
                                        {item.address}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button href={item.link} size="small">Google Maps</Button>
                                </CardActions>
                            </Card>
                        </Box>
                    ))}
                </Box>
            </Box>


            <Typography variant="h4" gutterBottom sx={{mb: 4, color: 'text.primary'}}>
                Comment venir ?
            </Typography>
            <Container maxWidth="md" sx={{mb: 4}}>
                <Paper elevation={3} sx={{p: {xs: 3, md: 5}, borderRadius: 3}}>

                    <Box>
                        <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                            <DirectionsCarIcon sx={{mr: 2, color: 'primary.main', fontSize: 30}}/>
                            <Typography variant="h5">
                                En voiture
                            </Typography>
                        </Box>


                        <Typography variant="body2">
                            <strong>La Mairie de Faremoutiers</strong> est située proche de rues avec des places
                            gratuites. Trois parkings sont situés à proximité :
                        </Typography>


                        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1.5, mt: 3}}>
                            {parkingsData.map((item, index) => (
                                <Box key={index} sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                                    <Box sx={{
                                        width: '1.2rem',
                                        height: '1.2rem',
                                        flexShrink: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <Box
                                            component="img"
                                            src={item.ok ? parkingIcon : parkingForbiddenIcon}
                                            alt={item.ok ? "Parking autorisé" : "Ne pas stationner"}
                                            sx={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                objectFit: 'contain',
                                            }}
                                        />
                                    </Box>
                                    <Typography variant="body2" sx={{color: 'text.primary'}}>
                                        <strong>{item.name}</strong> - {item.comment}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>

                        <Box sx={{
                            mt: 4,
                            width: '100%',
                            maxWidth: '600px',
                            mx: 'auto',
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Box
                                component="img"
                                src={stationnement_mairie}
                                alt="Stationnement mairie"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain'
                                }}
                            />
                        </Box>
                        <Divider sx={{mb: 4, mt: 4}}></Divider>
                        <Typography variant="body2">
                            <strong>Le Domaine de la Pépinière</strong> est uniquement accessible par la route, un
                            grand parking peut accueillir toutes les voitures à l'intérieur de la cour.
                        </Typography>
                        <Box sx={{
                            mt: 4,
                            width: '100%',
                            maxWidth: '600px',
                            mx: 'auto',
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                            <Box
                                component="img"
                                src={stationnement_pepiniere}
                                alt="Stationnement Pépinière"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain'
                                }}
                            />
                        </Box>
                    </Box>
                </Paper></Container>


            <Container maxWidth="md">
                <Paper elevation={3} sx={{p: {xs: 3, md: 5}, borderRadius: 3}}>

                    <Box >
                        <Box sx={{display: 'flex', alignItems: 'center', mb: 3}}>
                            <TrainIcon sx={{mr: 2, color: 'primary.main', fontSize: 30}}/>
                            <Typography variant="h5">
                                En train
                            </Typography>
                        </Box>




                        {!isMobile && (
                            <TableContainer
                                component={Paper}
                                elevation={3}
                                sx={{
                                    maxWidth: 1000,
                                    mx: 'auto',
                                    mt: 4,
                                    bgcolor: 'background.default',
                                }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><Typography fontWeight={600}>Lieu</Typography></TableCell>
                                            <TableCell><Typography fontWeight={600}>Gare la plus proche</Typography></TableCell>
                                            <TableCell><Typography fontWeight={600}>Distance Lieu - Gare</Typography></TableCell>
                                            <TableCell><Typography fontWeight={600}>Ligne</Typography></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {howToComeData.map((row, i) => (
                                            <TableRow key={i}>
                                                <TableCell><Typography>{row.lieu}</Typography></TableCell>
                                                <TableCell><Typography>{row.gare}</Typography></TableCell>
                                                <TableCell><Typography>{row.distance}</Typography></TableCell>
                                                <TableCell>
                                                    <Box component="img" src={row.ligneImg} sx={{ width: "25%" }} />
                                                    <Typography>{row.ligneLabel}</Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}

                        {isMobile && (
                            <Box sx={{ mt: 4, display: "grid", gap: 3, }}>
                                {howToComeData.map((row, i) => (
                                    <Paper key={i} elevation={3} sx={{ p: 3, borderRadius: 3,
                                        bgcolor: 'background.default',}}>
                                        <Box sx={{ mb: 2 }}>
                                            <Typography fontWeight={600} color="text.secondary">
                                                Lieu
                                            </Typography>
                                            <Typography>{row.lieu}</Typography>
                                        </Box>

                                        <Box sx={{ mb: 2 }}>
                                            <Typography fontWeight={600} color="text.secondary">
                                                Gare la plus proche
                                            </Typography>
                                            <Typography>{row.gare}</Typography>
                                        </Box>

                                        <Box sx={{ mb: 2 }}>
                                            <Typography fontWeight={600} color="text.secondary">
                                                Distance lieu - gare
                                            </Typography>
                                            <Typography>{row.distance}</Typography>
                                        </Box>

                                        <Box>
                                            <Typography fontWeight={600} color="text.secondary">
                                                Ligne
                                            </Typography>

                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1.5,
                                                }}
                                            >
                                                <Box
                                                    component="img"
                                                    src={row.ligneImg}
                                                    alt={row.ligneLabel}
                                                    sx={{
                                                        width: 60,
                                                        height: "auto",
                                                        objectFit: "contain",
                                                        flexShrink: 0,
                                                    }}
                                                />

                                                <Typography>
                                                    {row.ligneLabel}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Paper>
                                ))}
                            </Box>
                        )}
                    </Box>

                </Paper>
            </Container>
        </>
    );
};

export default HowToCome;